import { IParamsGetSchool } from 'app/api/school/model'

export const SchoolKeys = {
  allSchools: ['Schools'] as const,
  listSchools: () => [...SchoolKeys.allSchools, 'listSchools'] as const,
  listSchool: (filter?: IParamsGetSchool) =>
    [...SchoolKeys.listSchools(), { filter }] as const,
}
